
jQuery(document).ready((function(){jQuery("ul.tabs li").click((function(){var r=$(this).attr("data-tab");jQuery("ul.tabs li").removeClass("current"),jQuery(".tab-content").removeClass("current"),jQuery(this).addClass("current"),jQuery("#"+r).addClass("current")}))}));
//# sourceMappingURL=/s/files/1/0419/3361/t/195/assets/custom-fields-tabs.js.map?v=1639847692
